export default ({ state, commit, dispatch, rootState }, column) => {
    let authId = rootState.user.user.id
    const providers = rootState.provider.providers.reduce((acc, provider) => {
        acc.push(provider.provider)
        return acc
    }, [])
    const currProvider = rootState.provider.id
    const uploadUrl = state.fileUploadKey
    return dispatch('post', {
        url: "/provider/" + currProvider + "/import",
        data: {
            url: uploadUrl,
            column,
            providers: providers,
            provider: currProvider
        }
    }, {
        root: true
    }).then((result) => {
        dispatch('getAllImportErrors', { provider: providers})
        providers.forEach(providerId => {
            dispatch('loadLineup', { id: providerId })
        })
        return result
        //commit('uploadFileSuccess', result)
    }).catch(err => {
        console.log(err)
        commit("uploadFileError", err)
    })
}